class AdvancePaymentManagement {
    constructor(deudor, fechaDesde, fechaHasta, importeDesde, importeHasta, fechaAltaDesde, fechaAltaHasta) {
        this.deudor = deudor;
        this.fechaDesde = fechaDesde;
        this.fechaHasta = fechaHasta;
        this.importeDesde = importeDesde;
        this.importeHasta = importeHasta;
        this.fechaAltaDesde = fechaAltaDesde;
        this.fechaAltaHasta = fechaAltaHasta;
    }
}

export default AdvancePaymentManagement;